module.exports = __webpack_public_path__ + "images/Bill-5fda02.png";